module.exports = __webpack_public_path__ + "img/vue1-lacet_noir.0d771d4f.png";